import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { EditorMode } from '@sloyd/ui';
import { useMemo } from 'react';
import { $a } from 'shared-base';
import styled from 'styled-components';
import TextureResolutionContainer from './TextureResolution.container';

export type EditorModeContainerProps = {};

export function EditorModeContainer(_props: EditorModeContainerProps) {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);
  const focusMode = useSelector(selectors.base.$focusMode);
  const isEmployee = useSelector(selectors.base.$isEmployee);
  const projectType = useSelector(selectors.single.$projectType);
  const { editMode } = appState;

  const flavour = projectType !== 'scene' ? 'object' : 'scene';

  const callbacks = useMemo(
    () => ({
      onToggle: (mode: string) => {
        dispatch($a('EDITOR', 'toggleMode', '', { mode }));
      },
    }),
    []
  );

  if (focusMode !== 'existing' && projectType !== 'scene') return null;

  return (
    <Wrapper>
      <EditorMode
        mode={editMode}
        flavour={flavour}
        onToggle={callbacks.onToggle}
        hideScene={!isEmployee}
      >
        {editMode === 'material' ? <TextureResolutionContainer /> : <Gap />}
      </EditorMode>
    </Wrapper>
  );
}

export const Gap = styled.div`
  width: 80px;
`;

export const Wrapper = styled.div`
  position: absolute;
  right: 290px;
  top: 20px;
`;

export default EditorModeContainer;
